import URLS from "../../../../util/urls";
import axios from 'axios';

const state = {
  saldoConta: 0,
  titulos: [],
  extrato: {
    movimentacoes: []
  }
}

const mutations = {
  atualizarSaldo(state, payload) {
    state.saldoConta = payload
  },

  atualizarTitulos(state, payload) {
    state.titulos.push(...payload.recibos);
    state.titulos.push(...payload.boletosAvulsos);
  },

  limparTitulos(state) {
    state.titulos = []
  },
  
  removerTitulo(state, index) {
    state.titulos.splice(index, 1);
  },

  atualizarExtratoCora(state, payload) {
    if(payload.movimentacoes) {
      state.extrato = payload;
    }
  },

  atualizarExtratoAsaas(state, payload) {
    if(payload) {
      state.extrato = { movimentacoes: [...payload] };
    }
  },

  limparExtratoCora(state) {
    state.extrato = {
      movimentacoes: []
    }
  }
}

const actions = {
  getSaldoCora(context, payload) {
    return axios.post(URLS.TITULOS_API_GET_SALDO_CORA, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarSaldo', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch('getSaldoCora', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarBoletosCora(context, payload) {
    return axios.post(URLS.TITULOS_API_RECUPERAR_CORA, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('limparTitulos')
          context.commit('atualizarTitulos', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('listarBoletosCora', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarBoletosAsaas(context, payload) {
    return axios.post(URLS.TITULOS_API_RECUPERAR_ASAAS, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('limparTitulos')
          context.commit('atualizarTitulos', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('listarBoletosAsaas', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  pagarTituloCora(context, payload) {
    return axios.post((payload.mesSerie ? URLS.TITULOS_API_PAGAR_RECIBO_STAGE_CORA : URLS.TITULOS_API_PAGAR_BOLETO_AVULSO_STAGE_CORA), {...payload, index: undefined})
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('removerTitulo', payload.index)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('pagarTituloCora', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  cancelarTituloCora(context, payload) {
    return axios.post((payload.mesSerie ? URLS.TITULOS_API_CANCELAR_RECIBO_CORA : URLS.TITULOS_API_CANCELAR_BOLETO_AVULSO_CORA), {...payload, index: undefined})
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('removerTitulo', payload.index);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('cancelarTituloCora', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  cancelarTituloAsaas(context, payload) {
    return axios.post((payload.mesSerie ? URLS.TITULOS_API_CANCELAR_RECIBO_ASAAS : URLS.TITULOS_API_CANCELAR_BOLETO_AVULSO_ASAAS), {...payload, index: undefined})
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('removerTitulo', payload.index);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('cancelarTituloCora', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  recuperarExtratoCora(context, payload) {
    return axios.post(URLS.TITULOS_API_RECUPERAR_EXTRATO_CORA, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('limparExtratoCora')
          context.commit('atualizarExtratoCora', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('recuperarExtratoCora', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  recuperarExtratoAsaas(context, payload) {
    return axios.post(URLS.TITULOS_API_RECUPERAR_EXTRATO_ASAAS, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('limparExtratoCora')
          context.commit('atualizarExtratoAsaas', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('recuperarExtratoAsaas', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  atualizarTituloAsaas(context, payload) {
    return axios.post(URLS.TITULOS_API_ATUALIZAR_TITULO_ASAAS, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('atualizarTituloAsaas', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}